/* SADAHIROS: reusable editorial motion + locale-aware native product forms. */
(()=>{
 'use strict';
 const reduceMotion=matchMedia('(prefers-reduced-motion: reduce)');
 const motionRoots=new Set();
 const observer='IntersectionObserver'in window?new IntersectionObserver(entries=>entries.forEach(entry=>{if(entry.isIntersecting){entry.target.classList.add('is-visible');observer.unobserve(entry.target);}}),{threshold:.12}):null;
 function init(scope=document){
  scope.querySelectorAll('[data-sd-motion]').forEach(el=>{
   if(el.dataset.sdReady)return;el.dataset.sdReady='true';
   if(reduceMotion.matches||el.dataset.motion==='none'||!observer){el.classList.add('is-visible');return;}
   el.dataset.sdEnhanced='true';observer.observe(el);motionRoots.add(el);
  });
  scope.querySelectorAll('form[data-sd-add]').forEach(form=>{
   if(form.dataset.sdReady)return;form.dataset.sdReady='true';
   const select=form.querySelector('select[name="id"]');
   const validateSelection=()=>{
    if(!select)return;
    const optionLabel=form.querySelector('.sd-card__label')?.textContent.trim()||'商品仕様';
    select.setCustomValidity(select.required&&!select.value?optionLabel+'を選択してください。':'');
   };
   select?.addEventListener('invalid',validateSelection);
   validateSelection();
   select?.addEventListener('change',()=>{
    validateSelection();
    const price=select.selectedOptions[0]?.dataset.price;
    const priceEl=form.closest('article')?.querySelector('[data-sd-price]');
    if(price&&priceEl&&!priceEl.hasAttribute('data-sd-price-range'))priceEl.textContent=price;
    form.querySelector('.sd-card__status').textContent='';
   });
   form.addEventListener('submit',async event=>{
    event.preventDefault();if(form.dataset.busy==='true')return;
    const status=form.querySelector('.sd-card__status');
    const button=form.querySelector('[type="submit"]');
    const label=button.querySelector('[data-sd-add-label]');
    if(!form.reportValidity())return;
    const data=new FormData(form);if(!data.get('id')){status.textContent='ご希望の商品仕様を選択してください。';return;}
    form.dataset.busy='true';button.disabled=true;button.setAttribute('aria-busy','true');label.textContent='カートに追加中…';status.textContent='';
    const cartLink=form.querySelector('.sd-card__cart-link');cartLink.hidden=true;
    try{
     const base=window.Shopify?.routes?.root||'/';
     const response=await fetch(base+'cart/add.js',{method:'POST',headers:{Accept:'application/json'},body:data});
     const result=await response.json();
     if(!response.ok||result.status){throw new Error(typeof result.description==='string'?result.description:'追加できませんでした。商品ページで在庫をご確認ください。');}
     status.textContent='カートに追加しました。';cartLink.hidden=false;
     document.dispatchEvent(new CustomEvent('sd:cart-added',{detail:{trigger:button}}));
     // Count refresh failure must not turn a successful addition into an apparent failure.
     try{const cartResponse=await fetch(base+'cart.js',{headers:{Accept:'application/json'}});if(cartResponse.ok){const cart=await cartResponse.json();document.querySelectorAll('[data-sd-cart-count]').forEach(el=>el.textContent=String(cart.item_count));}}catch{}
    }catch(error){status.textContent=error.message==='Failed to fetch'?'通信に失敗しました。接続を確認してもう一度お試しください。':error.message;}
    finally{form.dataset.busy='false';button.disabled=false;button.removeAttribute('aria-busy');label.textContent='カートに入れる';}
   });
  });
 }
 let scheduled=false;
 function updateMotion(){
  scheduled=false;if(reduceMotion.matches)return;
  motionRoots.forEach(el=>{
   if(!el.isConnected){motionRoots.delete(el);return;}
   if(el.dataset.motion!=='parallax')return;
   const rect=el.getBoundingClientRect();if(rect.bottom<0||rect.top>innerHeight)return;
   const progress=Math.max(0,Math.min(1,(innerHeight-rect.top)/(innerHeight+rect.height)));
   el.style.setProperty('--sd-image-shift',(-8+progress*8).toFixed(2)+'%');
  });
 }
 const schedule=()=>{if(!scheduled){scheduled=true;requestAnimationFrame(updateMotion);}};
 addEventListener('scroll',schedule,{passive:true});addEventListener('resize',schedule,{passive:true});
 reduceMotion.addEventListener('change',()=>{if(reduceMotion.matches){motionRoots.forEach(el=>{el.classList.add('is-visible');el.style.removeProperty('--sd-image-shift');});}schedule();});
 document.addEventListener('click',event=>{if(event.target.closest('.sd-header__mobile nav a'))document.querySelector('.sd-header__mobile')?.removeAttribute('open');});
 document.addEventListener('keydown',event=>{if(event.key==='Escape')document.querySelector('.sd-header__mobile')?.removeAttribute('open');});
 document.addEventListener('shopify:section:load',event=>{init(event.target);schedule();});
 if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',()=>{init();schedule();});else{init();schedule();}
})();
